import { Pipe, PipeTransform } from '@angular/core';

import { ThemeMode } from 'src/shared/services/theme.service';

@Pipe({
    name: 'themeIcon',
    standalone: false,
    pure: true
})
export class ThemeIconPipe implements PipeTransform {
  transform(mode: ThemeMode, variant: 'default' | 'white' = 'default'): string {
    const icon = mode === 'dark' ? 'sunny-outline' : 'moon-outline';
    const suffix = variant === 'white' ? '-white' : '';
    return `assets/svg/${icon}${suffix}.svg`;
  }
}
